import { useNavigate } from 'react-router-dom';
import { FormUtility } from '../../Utility/FormUtility';
import { useSelector } from 'react-redux';
import { rolesCodes } from '../../../constants/Roles';
import { useEffect, useState } from 'react';

export default function Home() {
  const navigate = useNavigate();
  const roles = useSelector((state) => state.role);
  const utility = new FormUtility({ data: roles });

  useEffect(() => {
    utility.clearSessionStorageBySuffixes(['_options', '_filtri_avanzati']);
  }, []);

  
const [activeAccordion, setActiveAccordion] = useState(null);

const toggleAccordion = (id) => {
 
  setActiveAccordion(activeAccordion === id ? null : id);
};

  return (
    <div className="rtds-container-xxs rtds-py-6">
      <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
        <div className="rtds-flex rtds-items-center rtds-justify-between">
          <h1 className="rtds-heading-2">Menù</h1>
        </div>
        <div className="rtds-flex rtds-justify-center">
          <div className="rtds-w-full">
            {utility.checkRoles([rolesCodes.regione]) && (
              <button
                type="button"
                onClick={() => navigate("/gestione-domande")}
                className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--paper-clip`}
                  />
                </svg>{" "}
                Domande
              </button>
            )}
            {utility.checkRoles([rolesCodes.regione]) && (
              <button
                type="button"
                onClick={() => navigate("/gestione-email")}
                className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--envelope`}
                  />
                </svg>
                Email Massive
              </button>
            )}

            <div className="rtds-accordion rtds-accordion--widget">
              <div className="rtds-accordion__item">
                <button
                  type="button"
                  aria-expanded={activeAccordion === "misura"}
                  className="rtds-w-full rtds-relative rtds-flex rtds-items-center rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group rtds-group/button rtds-btn--primary"
                  aria-controls="accordionSection-1"
                  id="accordion1id"
                  onClick={() => toggleAccordion("misura")}
                >
                  <span className="rtds-accordion__trigger-label">
                    <svg
                      className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--wrench`}
                      />
                    </svg>{" "}
                    Gestione Misura
                  </span>
                  <span className="rtds-accordion__icon rtds-absolute rtds-right-2 rtds-flex rtds-p-2 rtds-h-auto rtds-transition-all rtds-right-0">
                    <svg
                      className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-transition-all is-expand-arrow group-aria-expanded:rtds-rotate-180"
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-up`}
                      />
                    </svg>
                  </span>
                </button>

                <div
                  hidden={activeAccordion !== "misura"}
                  id="accordionSection-1"
                  role="region"
                  aria-labelledby="accordion1id"
                  class="rtds-transition-all rtds-p-5 rtds-pb-0 rtds-border-2 rtds-border-brand-00 rtds-rounded-md"
                >
                  {utility.checkRoles([rolesCodes.regione]) && (
                    <button
                      type="button"
                      onClick={() => navigate("/gestione-avvisi")}
                      className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--megaphone`}
                        />
                      </svg>{" "}
                      Avvisi
                    </button>
                  )}

                  {utility.checkRoles([rolesCodes.regione]) && (
                    <button
                      type="button"
                      onClick={() => navigate("/gestione-fasi")}
                      className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--calendar-days`}
                        />
                      </svg>{" "}
                      Fasi
                    </button>
                  )}
                  {utility.checkRoles([rolesCodes.regione]) && (
                    <button
                      type="button"
                      onClick={() => navigate("/gestione-stato-domande")}
                      className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--list-bullet`}
                        />
                      </svg>{" "}
                      Stato Domande
                    </button>
                  )}
                  {utility.checkRoles([rolesCodes.regione]) && (
                    <button
                      type="button"
                      onClick={() => navigate("/gestione-anpr")}
                      className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--list-bullet`}
                        />
                      </svg>{" "}
                      ANPR
                    </button>
                  )}
                  {utility.checkRoles([rolesCodes.regione]) && (
                    <button
                      type="button"
                      onClick={() => navigate("/gestione-pagamenti")}
                      className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--currency-euro`}
                        />
                      </svg>{" "}
                      Pagamenti
                    </button>
                  )}
                  {utility.checkRoles([rolesCodes.regione]) && (
                    <button
                      type="button"
                      onClick={() => navigate("/gestione-istruttorie")}
                      className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--bookmark`}
                        />
                      </svg>{" "}
                      Istruttorie ARS
                    </button>
                  )}
                  {utility.checkRoles([rolesCodes.regione]) && (
                    <button
                      type="button"
                      onClick={() => navigate("/gestione-indirizzi-studio")}
                      className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--academic-cap`}
                        />
                      </svg>{" "}
                      Scuole e indirizzi di studio
                    </button>
                  )}
                  {utility.checkRoles([rolesCodes.regione]) && (
                    <button
                      type="button"
                      onClick={() => navigate("/gestione-adesione-enti")}
                      className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--building-library`}
                        />
                      </svg>{" "}
                      Anagrafe Enti
                    </button>
                  )}
                  {(utility.checkRoles([rolesCodes.regione]) ||
                    (utility.checkRoles([rolesCodes.comuneReferente]) &&
                      roles.referenze.find(
                        (r) => r.id.toString() === roles.enteSelected,
                      ))) && (
                    <button
                      type="button"
                      onClick={() =>
                        navigate(
                          "/gestione-operatori" +
                            (utility.checkRoles([rolesCodes.comuneReferente])
                              ? "/" + roles.enteSelected
                              : ""),
                        )
                      }
                      className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--users`}
                        />
                      </svg>{" "}
                      Operatori comunali
                    </button>
                  )}
                </div>
              </div>

              <div className="rtds-accordion__item ">
                <button
                  type="button"
                  aria-expanded={activeAccordion === "audit"}
                  className="rtds-w-full rtds-relative rtds-flex rtds-items-center rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group rtds-group/button rtds-btn--primary"
                  aria-controls="accordionSection-1"
                  id="accordion1id"
                  onClick={() => toggleAccordion("audit")}
                >
                  <span className="rtds-accordion__trigger-label">
                    <svg
                      className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--magnifying-glass`}
                      />
                    </svg>{" "}
                    Audit
                  </span>
                  <span className="rtds-accordion__icon rtds-absolute rtds-right-2 rtds-flex rtds-p-2 rtds-h-auto rtds-transition-all rtds-right-0">
                    <svg
                      className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-transition-all is-expand-arrow group-aria-expanded:rtds-rotate-180"
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                    >
                      <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-up`} />
                    </svg>
                  </span>
                </button>

                <div
                  hidden={activeAccordion !== "audit"}
                  id="accordionSection-1"
                  role="region"
                  aria-labelledby="accordion1id"
                  class="rtds-transition-all rtds-p-5 rtds-pb-0 rtds-border-2 rtds-border-brand-00 rtds-rounded-md"
                >
                  {utility.checkRoles([rolesCodes.regione]) && (
                    <button
                      type="button"
                      onClick={() => navigate("/gestione-errori")}
                      className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--exclamation-triangle`}
                        />
                      </svg>{" "}
                      Errori
                    </button>
                  )}
                  {utility.checkRoles([rolesCodes.regione]) && (
                    <button
                      type="button"
                      onClick={() => navigate("/gestione-eventi")}
                      className="rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary"
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--clock`}
                        />
                      </svg>{" "}
                      Eventi
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*<div>
          <p className='rtds-text-center'>
            Per eventuali quesiti è possibile inoltrare una mail a <a className='rtds-link ' href='mailto:librigratis@regione.toscana.it'>librigratis@regione.toscana.it</a>
          </p>
        </div>*/}
      </div>
    </div>
  );
}
